import ScrollToLink from '../../ScrollToLink';
import { jsx as _jsx } from "react/jsx-runtime";
const CompareTrialPlanTableLink = () => {
  return /*#__PURE__*/_jsx(ScrollToLink, {
    cssSelector: "#compare-trial-plan-table"
  });
};
export default CompareTrialPlanTableLink;